import { useRef, useState } from "react";
import Navigator from "../../components/Navigator";
import styles from "./Main.module.css";
import Divider from "../components/Divider";
import ProductDetails from "../components/ProductDetails";
import CTAButton from "../../components/CTAButton";
import { Slide } from "react-awesome-reveal";
import Footer from "../../components/Footer";
import ObservedSection from "../../components/ObservedSection";

const productImages = [
    require('../../images/product/1.png'),
    require('../../images/product/2.png'),
    require('../../images/product/3.jpg'),
    require('../../images/product/4.png'),
    require('../../images/product/5.png'),
    require('../../images/product/6.png'),
]
const Main = () => {
    const [showButton, setShowButton] = useState(false);
    const [direction, setDirection] = useState("up");
    const thumbnailsRef = useRef()
    const [imgIndex, setImgIndex] = useState(0)
    const [scrollPosition, setScrollPosition] = useState(0)

    function handleScroll() {
        if (scrollPosition == 0) {
            thumbnailsRef.current.scrollTo({ left: 300, behavior: "smooth" })
            setScrollPosition(200)
        }
        else {
            thumbnailsRef.current.scrollTo({ left: 0, behavior: "smooth" })
            setScrollPosition(0)
        }
    }

    function handleScrollToTop(e) {
        e.preventDefault(); // prevent default jump
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function handleHideCTA() {
        if (!showButton) return
        setTimeout(() => setShowButton(false), 100)
        setDirection("down")
    }

    function handleShowCTA() {
        if (showButton) return
        setTimeout(() => setShowButton(true), 100)
        setDirection("up")
    }

    return (
        <div className={styles.screen}>
            <Navigator />

            <main className={styles.main}>
                <div className={styles.container}>
                    {/* Left: Product Image */}
                    <div>
                        <div className={styles.product_img}>
                            <img
                                src={productImages[imgIndex]}
                                alt="Vision Training Device"
                            />
                        </div>

                        <div className={styles.product_thumbnails}>
                            {scrollPosition > 0 && <a onClick={handleScroll}>
                                <img
                                    src={require('../../images/product/arrow.png')}
                                    alt="Thumbnail"
                                    className={styles.thumbnail_arrow}
                                    style={{ transform: 'rotate(180deg)' }}

                                />
                            </a>}
                            <div ref={thumbnailsRef}>
                                {productImages.map((image, i) => {

                                    return <img
                                        src={image}
                                        key={i}
                                        alt="Thumbnail"
                                        className={styles.product_thumbnail}
                                        onClick={() => setImgIndex(i)}
                                    />
                                }
                                )}
                            </div>
                            {scrollPosition == 0 && <a onClick={handleScroll}>
                                <img
                                    src={require('../../images/product/arrow.png')}
                                    alt="Thumbnail"
                                    className={styles.thumbnail_arrow}

                                />
                            </a>}

                        </div>
                    </div>

                    {/* Right: Product Details */}
                    <div className={styles.productDetails}>
                        <div className={styles.product_title}>
                            OTUS, Your Daily Vision Trainer
                        </div>
                        <p style={{color: 'black', fontSize: 18, marginTop: 22}}>
                            Manage eye fatigue and age-related vision changes with daily vision training.
                        </p>
                        <ul className={styles.product_benefits}>
                            <li><b>8-lens eye training</b> <span style={{color: '#7E7E7E'}}>for daily vision care</span></li>
                            <li><b>Near & far focus support</b></li>
                            <li><b>Open-view design</b>  <span style={{color: '#7E7E7E'}}>for everyday use</span></li>
                        </ul>

                        {/* Pricing */}
                        <div>

                        </div>
                        <div className={styles.pricing}>
                            <div>
                                <p className={styles.pricing_label} style={{paddingTop: 26, paddingBottom: 13}}>Retail Price</p>
                                <p className={styles.original_price} style={{paddingTop: 26, paddingBottom: 13}}>
                                    S$ 453
                                </p>
                            </div>
                            <div>
                                <p className={styles.pricing_label}>Special Price</p>
                                <div className={styles.special_price}>
                                    S$ 299 <span className={styles.off_tag}>34% SALE</span>
                                </div>
                            </div>
                           
                            <div>
                                <p className={styles.pricing_label}>SPay Later</p>
                                <p className={styles.special_price} style={{paddingBottom: "26px", marginTop: '4px'}}>S$ 49.8 <span style={{ fontWeight: 400 }}>x</span> 6 months<br />
                                    <span className={styles.special_price_detail} >(Pay in 6 installments with Shopee sPay Later)</span><br/>
                                </p>
                            </div>
                        </div>
                        <div className={styles.pricing} style={{borderTop: 'solid 0px'}}>
                            <div>
                                <p className={styles.pricing_label} style={{background: "#EFEFEF", height: 71, alignItems: 'center', display: 'flex'}}>Warranty</p>
                                <p className={styles.warranty}>1-Year Warranty <span style={{fontSize: '12px', color: "#707070", paddingLeft: "5px"}}>(Free Repair Service Included)</span></p>
                            </div>
                        </div>

                        {/* CTA Button */}
                        <ObservedSection
                            onEnter={() => handleHideCTA()}
                            onLeave={() => handleShowCTA()}
                        >
                            <CTAButton
                                className={styles.cta}
                                titleClass={styles.cta_title}
                                subtitleClass={styles.cta_sub}
                                iconClass={styles.cta_icon}
                            />
                        </ObservedSection>
                    </div>
                </div>
                <Divider />
                <ProductDetails onCtaEnter={handleHideCTA} onCtaExit={handleShowCTA} />
                <Slide
                    duration={500}
                    direction={direction}
                    className={styles.sticky_cta_container}
                    style={{ display: showButton ? "flex" : 'none', bottom: direction == "down" ? '-100px' : "30px" }}>
                    <CTAButton
                        className={styles.sticky_cta}
                        titleClass={styles.sticky_cta_title}
                        subtitleClass={styles.sticky_cta_sub}
                        iconClass={styles.cta_icon}
                    />
                </Slide>

            </main>
            <a onClick={handleScrollToTop} href="#" className={styles.arrow_top}>
                <img src={require('../../images/arrow_top.png')} />
            </a>
            <Footer />
        </div>
    );
};

export default Main;
